import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { LOCALE_ES } from '@app/@core/constants/common.constants';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { ExcelService } from '@app/@shared/services/print/excel.service';
import { DatepickerUtilsService } from '@app/@shared/services/utils/datepicker-utils.service';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { AdminStore } from '../admin-service/admin-service.store';
import { ResponseCombosAdministratorReportDTO } from '../model/users-model';

@UntilDestroy()
@Component({
  selector: 'app-adminReport',
  templateUrl: './adminReport.component.html',
  styleUrls: ['./adminReport.component.scss'],
})
export class adminReportComponent implements OnInit {
  public adminReportForm: FormGroup;

  divisionList: CommonDataDTO[];
  tipoBSList: CommonDataDTO[] = [
    { id: '', value: 'TODOS' },
    { id: 'S', value: 'Si' },
    { id: 'N', value: 'No' },
  ];
  activadoList: CommonDataDTO[] = [
    { id: '', value: 'TODOS' },
    { id: 'S', value: 'Si' },
    { id: 'N', value: 'No' },
  ];
  commercialExternalList: CommonDataDTO[];
  commercialInternalList: CommonDataDTO[];
  officesList: CommonDataDTO[];
  profilesList: CommonDataDTO[] = [];
  attributionList: CommonDataDTO[];
  ordenList: CommonDataDTO[] = [
    { id: '', value: '' },
    { id: '1', value: 'Código host' },
    { id: '10', value: 'Fecha Alta' },
    { id: '11', value: 'Fecha Baja' },
    { id: '7', value: 'Activado' },
    { id: '12', value: 'División' },
    { id: '8', value: 'Perfil' },
    { id: '17', value: 'C. interno' },
    { id: '18', value: 'C.externo' },
    { id: '20', value: 'D. Oficina' },
    { id: '19', value: 'Tipo BS' },
  ];
  minDateInit: Date;
  btnSendDisabled: boolean = true;
  dataSource = new MatTableDataSource<any>();

  //Order of the headers' labels displayed in the table, using id
  displayedColumns = [
    'request',
    'version',
    'date',
    'nif',
    'docResult',
    'statusLogalty',
    'statusWeb',
    'statusHost',
    'type',
    'action',
    'more',
  ];

  columnsToDisplay: any[] = this.displayedColumns.slice();

  public head = [
    [
      'Cod. Usuario',
      'Tipo',
      'Cod. Padre',
      'Tipo Padre',
      'Usuario Web',
      'Email',
      'Nombre',
      'Apellido1',
      'Apellido2',
      'NIF',
      'Fecha Alta',
      'F. Baja',
      'Act.',
      'Div.',
      'Perfil',
      'Nif Comercial Int.',
      'Nif Comercial Ext.',
      'Nif Dir Oficina',
      'Descripción Usuario',
      'Tipo BS',
    ],
  ];

  constructor(
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private adminStore: AdminStore,
    private excelService: ExcelService,
    private dialog: MatDialog,
    private customValidators: CustomValidatorsService,
    private datepickerUtils: DatepickerUtilsService
  ) {
    const currentDate = new Date();
    this.minDateInit = currentDate;
  }

  ngOnInit(): void {
    this.adminReportForm = this.formBuilder.group(
      {
        codHost: [''],
        division: [''],
        typeBS: [''],
        perfil: [''],
        attribution: [''],
        dateInit: [''],
        dateEnd: [''],
        dateInitLow: [''],
        dateEndLow: [''],
        internal: [''],
        external: [''],
        office: [''],
        active: [''],
        orden1: [''],
        orden2: [''],
        orden3: [''],
      },
      {
        validators: [
          this.customValidators.isDateValid('dateInit', 'dateEnd', 'dateInvalid'),
          this.customValidators.isDateValid('dateInitLow', 'dateEndLow', 'dateLowInvalid'),
        ],
      }
    );

    this.translateService.currentLang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan();
    this.translateService.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe((event) =>
        event.lang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan()
      );

    this.getProfiles();
    this.adminStore.getCombosReportAdministrator().then(
      (data: ResponseCombosAdministratorReportDTO) => {
        this.commercialExternalList = data.externalCommercialUsers;
        this.commercialExternalList.unshift({ id: '', value: 'TODOS' });
        this.commercialInternalList = data.internalCommercialUsers;
        this.commercialInternalList.unshift({ id: '', value: 'TODOS' });
        this.divisionList = data.divisions;
        this.divisionList.unshift({ id: '', value: 'TODOS' });
        this.officesList = data.offices;
        this.officesList.unshift({ id: '', value: 'TODOS' });
        this.attributionList = data.attributions;
        this.attributionList.unshift({ id: '', value: 'TODOS' });

        this.adminReportForm.controls.division.setValue(this.divisionList[0].id);
        this.adminReportForm.controls.internal.setValue(this.commercialInternalList[0].id);
        this.adminReportForm.controls.external.setValue(this.commercialExternalList[0].id);
        this.adminReportForm.controls.office.setValue(this.officesList[0].id);
        this.adminReportForm.controls.active.setValue(this.activadoList[0].id);
        this.adminReportForm.controls.typeBS.setValue(this.tipoBSList[0].id);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  ngAfterViewInit(): void {
    this.adminReportForm.valueChanges.subscribe((formValues: any) => {
      for (var key in formValues) {
        if (formValues.hasOwnProperty(key)) {
          if (
            key !== 'orden1' &&
            key !== 'orden2' &&
            key !== 'orden3' &&
            formValues[key] !== '' &&
            formValues[key] !== null
          ) {
            this.btnSendDisabled = false;
            break;
          } else {
            this.btnSendDisabled = true;
          }
        }
      }
      // Check Discharge Dates and leave Dates.
      this.checkDateDisabled();
    });
  }

  onAttributionSelected() {
    if (this.adminReportForm.controls.attribution.value !== '') {
      this.adminReportForm.controls.perfil.disable();
    } else {
      this.adminReportForm.controls.perfil.enable();
    }
  }

  onPerfilSelected() {
    if (this.adminReportForm.controls.perfil.value !== '') {
      this.adminReportForm.controls.attribution.disable();
    } else {
      this.adminReportForm.controls.attribution.enable();
    }
  }

  exportReportAdmin() {
    this.adminStore.resultsAdminReport(this.adminReportForm).then(
      (data) => {
        this.createExcel(data);
      },
      (error) => {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = { text: this.translateService.instant('adminReport.error'), icon: 'icon-ic_circle_cross' };
        this.dialog.open(ResponseDialogComponent, dialogConfig);
      }
    );
  }

  createExcel(data: any) {
    let dataForExcel: any[] = [];

    data.forEach((row: any) => {
      for (var clave in row) {
        if (row.hasOwnProperty(clave)) {
          if (row[clave] === null) {
            row[clave] = ' ';
          }
        }
      }

      console.log(row);
      const { ...data } = row;
      const dataExcelOrder = JSON.stringify(data, [
        'userId',
        'userType',
        'parentId',
        'parentType',
        'username',
        'email',
        'name',
        'firstSurname',
        'lastSurname',
        'nif',
        'registerDate',
        'dropDate',
        'activated',
        'division',
        'userClass',
        'internalTrader',
        'externalTrader',
        'office',
        'userDesc',
        'userTypeBS',
      ]);

      const ObjectDataExcel = JSON.parse(dataExcelOrder);
      dataForExcel.push(Object.values(ObjectDataExcel));
    });

    const excelData = { headers: this.head[0], data: dataForExcel };
    this.excelService.exportExcelAdminReport(excelData);
  }

  onTypeBsSelectionChange(value: string) {
    this.profilesList = [];
    this.getProfiles(value);
  }

  getProfiles(typeBs?: string) {
    this.adminStore.getProfilesAdminReport(typeBs).then(
      (data) => {
        this.profilesList = data;
        this.profilesList.unshift({ id: '', value: 'TODOS' });
      },
      (error) => console.error(error)
    );
  }

  checkDateDisabled() {
    var dates = this.adminReportForm.value;
    for (var key in dates) {
      if (dates[key] == null) {
        dates[key] = '';
      }
    }
    if (dates.dateInit != '' && dates.dateEnd != '' && dates.dateInitLow != '' && dates.dateEndLow != '') {
      this.btnSendDisabled = false;
    } else if (dates.dateInit != '' && dates.dateEnd != '') {
      if (dates.dateInitLow != '' || dates.dateEndLow != '') {
        this.btnSendDisabled = true;
      } else {
        this.btnSendDisabled = false;
      }
    } else if (dates.dateInitLow != '' && dates.dateEndLow != '') {
      if (dates.dateInit != '' || dates.dateEnd != '') {
        this.btnSendDisabled = true;
      } else {
        this.btnSendDisabled = false;
      }
    } else {
      this.btnSendDisabled = true;
    }
  }
}
